import { render, staticRenderFns } from "./ControlsTreeExpansionPanels.vue?vue&type=template&id=5f5d4276&"
import script from "./ControlsTreeExpansionPanels.vue?vue&type=script&lang=ts&"
export * from "./ControlsTreeExpansionPanels.vue?vue&type=script&lang=ts&"
import style0 from "./ControlsTreeExpansionPanels.vue?vue&type=style&index=0&id=5f5d4276&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports